import { PaneArea } from '../../../types/shared'
import HorizontalLine from '../../canvas/horizontal_line'
import { IScaledLineAttrs } from '../../canvas/scaled_line'
import PaneModel from '../../models/pane'

type Area = PaneArea
type Attrs = IScaledLineAttrs
type PartialAttrs = Partial<Attrs>

class HorizontalLineCreator extends HorizontalLine<Attrs> {
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    this.attrs.y1 = startArea.y
    this.attrs.y2 = startArea.y

    setTimeout(() => {
      this.replaceMyself(HorizontalLine.fromObject<HorizontalLine>(this.attrs, this.model))
      toolsCallback()
    })

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }
}

export default HorizontalLineCreator
